import { RewardsProgramPreferenceState } from '@features/rewards-program/store/reducers/rewards-program-preference.reducer';
import { createFeatureSelector } from '@ngrx/store';
import { RewardsProgramState } from './rewards-program.reducer';

export const getRewardsProgramState =
  createFeatureSelector<RewardsProgramState>('rewardsProgram');

export const getRewardsProgramPreferenceState =
  createFeatureSelector<RewardsProgramPreferenceState>(
    'rewardsProgramPreference',
  );
